export const WITHIN_6KM = 'within_6km';
export const WITHIN_RIYADH = 'within_riyadh';
export const OUTSIDE_RIYADH = 'outside_riyadh';
